import { Typography } from "@mui/material";
import { SubmitButton } from "@avenue-8/sidekick-ui";
import { blurActiveElement } from "@shared/utils/blur-active-element";
import { useUIStore } from "@store/ui.store";

type Props = {
  userName: string | undefined;
  userEmail: string;
  userId: string;
  onDeleteUser: (params: { userId: string }) => Promise<void>;
  isDeleting: boolean;
};

export const AdminDeleteUser = (props: Props) => {
  const {
    userName = "Unknown",
    userEmail,
    userId,
    onDeleteUser,
    isDeleting,
  } = props;
  const confirmDialog = useUIStore((state) => state.confirmDialog);

  const handleDeleteClick = async () => {
    const answer = await confirmDialog({
      title: "Delete user?",
      content: (
        <>
          <Typography>{userName}</Typography>
          <Typography>{userEmail}</Typography>
          <Typography mt={2} mb={1} color="error">
            This action can&apos;t be undone.
          </Typography>
        </>
      ),
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    });

    blurActiveElement();

    if (!answer) return;

    onDeleteUser({ userId });
  };

  return (
    <SubmitButton
      type="button"
      variant="outlined"
      color="error"
      sx={{ justifySelf: "flex-start", minWidth: "160px" }}
      onClick={handleDeleteClick}
      isLoading={isDeleting}
      loadingText="Deleting..."
    >
      Delete user
    </SubmitButton>
  );
};
